<neo-avatar [config]="avatarConfig()" [autId]="autId()" />